import React from 'react';
import getPriceLabel from '@dashboard/services/translation/getPriceLabel';
import clsx from 'clsx';

export default function formatRecoveredStats({
  totalRecovered,
  totalAbandoned,
  totalRecoveredRevenue,
  currency,
}) {
  return (
    <div className={clsx('flex flex-row gap-1')}>
      <div>
        {totalRecovered ?? 0}/{(totalAbandoned ?? 0) + (totalRecovered ?? 0)}
      </div>
      <div> -</div>
      <div>
        {getPriceLabel({
          amount: totalRecoveredRevenue ?? 0,
          currency,
        })}
      </div>
    </div>
  );
}
